import React from "react";
import "tailwindcss/base.css";
import "tailwindcss/components.css";
import "tailwindcss/utilities.css";
import { useLanguage } from "../../LanguageContext";
import translations from "../../translation_experience_footer";

function Footer() {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <>
      <footer className="max-w-md pb-16 text-sm text-gray-500 sm:pb-0 font-mono">
        <p>
          {t.codedWith}{" "}
          <a
            href="https://code.visualstudio.com/"
            className="font-medium text-gray-400 hover:text-white focus-visible:text-white"
            target="_blank"
            rel="noreferrer noopener"
          >
            {t.visualStudioCode}
          </a>
          , {t.builtWith}{" "}
          <a
            href="https://reactjs.org/"
            className="font-medium text-gray-400 hover:text-white focus-visible:text-white"
            target="_blank"
            rel="noreferrer noopener"
          >
            {t.react}
          </a>
          , {t.tailwindCSS}, {t.deployedWith}{" "}
          <a
            href="https://vercel.com/"
            className="font-medium text-gray-400 hover:text-white focus-visible:text-white"
            target="_blank"
            rel="noreferrer noopener"
          >
            {t.vercel}
          </a>
          . {t.allTextSet}{" "}
          <a
            href="https://sourcefoundry.org/hack/"
            className="font-medium text-gray-400 hover:text-white focus-visible:text-white"
            target="_blank"
            rel="noreferrer noopener"
          >
            {t.hack}
          </a>
          .
        </p>
      </footer>
    </>
  );
}

export default React.memo(Footer);
